import React from 'react';
import Toggle from '../Toggle/Toggle';
import TextArea from '../TextArea/TextArea';
import { TIP_MESSAGE_MAX_LENGTH } from './constants';
import styles from './TipToggleMessage.module.scss';

export interface TipToggleMessageProps {
  /** Whether the toggle is checked (message enabled) */
  checked: boolean;
  /** Callback when toggle state changes */
  onToggleChange: (checked: boolean) => void;
  /** Current message text */
  message: string;
  /** Callback when message text changes */
  onMessageChange: (message: string) => void;
  /** Loading state */
  loading?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Maximum length for the message */
  maxLength?: number;
  /** Placeholder text for the textarea */
  placeholder?: string;
}

const TipToggleMessage: React.FC<TipToggleMessageProps> = ({
  checked,
  onToggleChange,
  message,
  onMessageChange,
  loading = false,
  className = '',
  maxLength = TIP_MESSAGE_MAX_LENGTH,
  placeholder = 'Enter custom message...',
}) => {
  const handleMessageChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onMessageChange(event.target.value);
  };

  return (
    <div className={`${styles.tipToggleMessage} ${className}`}>
      <div className={styles.toggleContainer}>
        <Toggle
          checked={checked}
          onChange={onToggleChange}
          loading={loading}
          additionalStyles={styles.leftAlignedToggle}
        />
      </div>
      <div className={styles.messageContainer}>
        <TextArea
          value={message}
          onChange={handleMessageChange}
          placeholder={placeholder}
          disabled={!checked}
          maxLength={maxLength}
          additionalStyles={styles.messageArea}
        />
      </div>
    </div>
  );
};

export default TipToggleMessage;
